import { Button, ButtonGroup, FilePicker, Tabs } from "@veneer/core";
import "./bulk-upload.scss";
import { ReactEventHandler, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { apiGetFileDownloadSiteAccount, apiGetWithHeader, apiPost, apiPostUploadFiles } from "../../../../services/service";
import { GET_FILE_DOWNLOAD_SITE_ACCOUNT, POST_FILE_UPLOAD, POST_PROFILE_PAGE_LOAD } from "../../../../services";
import { toast } from "react-toastify";
import TabTable from "./tab-table";
import { Col, Row } from "react-bootstrap";
import Loader from "@components/home-page/shared-components/loader/loader";
import SiteAccountTab from "./site-account-table";
import { isPolyAgent } from "utils";

export const BulkUpload = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [progress, setProgress] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState<string>("");
  const changeTabHandler = (id: any) => {
    setActiveTab(id);
  };
  const apiUrl: string = (window as any).apiurl ? (window as any).apiurl : "";

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const uploadFile = async (event: any) => {
    if (!selectedFile) {
      toast.error(t('HPI.ErrorMessage.PleaseSelectFileUpload.',{defaultValue:'Please select a file to upload.'}));
      setSelectedFile(null);
      setInputValue("");
      return null;
    }
    setProgress(true);
    const formData = new FormData();
    formData.append("uploadedfile_", selectedFile);

    try {
      setActiveTab(212);
      const response = await apiPostUploadFiles(POST_FILE_UPLOAD, formData);
      if (response.data) {
        toast.success(t('HPI.Success.FileUploadedSuccessfully',{defaultValue:'File uploaded successfully!'}));
        setProgress(false);
        event.target.value = "";
        setSelectedFile(null);
        setInputValue("");
        setActiveTab(0);
      } else {
        setProgress(false);
        toast.error(t('HPI.ErrorMessage.FileUploadfailed',{defaultValue:'File upload failed.'}));
        setSelectedFile(null);
        setInputValue("");
      }
    } catch (error) {
      setProgress(false);
      console.error("Error uploading file:", error);
      setSelectedFile(null);
      setInputValue("");
      toast.error(t('HPI.ErrorMessage.FileUploadFailedPleaseTryAgain',{defaultValue:'File upload failed. Please try again.'}));
    }
  };

  const clearHandle = () => {
    setSelectedFile(null);
  };
 
  const downloadFile = async (url: string) => {
    setProgress(true);
    try {
      const response = await apiGetFileDownloadSiteAccount(url);
      if (response.status === 200) {
        const contentType =
          response.headers.get("Content-Type") || "application/octet-stream";
        const siteAccount = t("HPI.ProfilePage.SiteLabel", {
              defaultValue: "Site Account",
            })
        const filename = `${siteAccount}.xlsx`; // Default filename, can be customized based on response headers if needed
        const blob = new Blob([response.data], { type: contentType });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(downloadUrl);
        }
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error(
        t('HPI.ErrorMessage.FileDownloadFailed', {
          defaultValue: 'File download failed.'
        })
      );
    } finally {
      setProgress(false);
    }
  };
  

  return (
    <div className="bulk-upload">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <h5>
        {t("HPI.Profilepage.generalinstruction.bulkupload", {
          defaultValue: "Please choose a template to download",
        })}
      </h5>
      <a
        href={`${apiUrl}CSVFiles/ExcelTemplates/Case_Template.xlsx`}
        className="link"
      >
        {" "}
        {t("HPI.Downloadcase", { defaultValue: "Download case template." })}
      </a>
      <a
        href={`${apiUrl}CSVFiles/ExcelTemplates/Entitlements_Template.xlsx`}
        className="link"
      >
        {" "}
        {t("HPI.DownloadEntitlement", {
          defaultValue: "Download entitlements template",
        })}
      </a>
      <a
        href={`${apiUrl}CSVFiles/ExcelTemplates/Contact_Template.xlsx`}
        className="link"
      >
        {" "}
        {t("HPI.DownloadContactTemplate", {
          defaultValue: "Download contact template",
        })}
      </a>
      <button
        onClick={() => {
          downloadFile(GET_FILE_DOWNLOAD_SITE_ACCOUNT);
        }}
        className="link"
      >
        {" "}
        {t("HPI.ProfilePage.BulkUpload.DownloadSites", {
          defaultValue: "Download site account",
        })}
        
      </button  >
      {(isPolyAgent) && (
      <a
        href={`${apiUrl}CSVFiles/ExcelTemplates/Poly_Case_Template.xlsx`}
        className="link"
      >
        {" "}
        {t("HPI.DownloadPolyCaseTemplate", { defaultValue: "Download poly case template" })}
      </a>
    )}
      <p className="body-regular mt-4">
        {t("HPI.Profilepage.generalinstruction.fileinstructions", {
          defaultValue:
            "Upon completion of the template, select the file by clicking on “Choose file” button. Then, please click the “Process” button below to upload the file.",
        })}
      </p>
      <div className="file-upload-container">
        <Col md={6}>
          <FilePicker
            id="file-picker"
            trailingButton
            name="upload_File"
            placeholder={t("HPI.Button.ChooseFile", {
              defaultValue: "Choose File",
            })}
            label={t("HPI.Button.ChooseFile", {
              defaultValue: "Choose File",
            })}
            ref={fileInputRef}
            separateLabel
            //onClear={() => clearHandle}
            value={inputValue}
            onChange={(event: any, files: any, s: string) => {
              setInputValue(s);
              handleFileChange(event);
            }}
          />
        </Col>
      </div>

      <ButtonGroup className="mt-5 mb-5">
        <Button onClick={uploadFile}>
          {t("HPI.Process", { defaultValue: "Process" })}
        </Button>
      </ButtonGroup>
      <div className="tab-container">
        <Tabs
          controlId="default"
          onChangeTab={changeTabHandler}
          selectedTabId={activeTab}
          tabs={[
            {
              id: 0,
              label: t("HPI.ProfilePage.CaseLabel", { defaultValue: "Case" }),
              content: (
                <Row>
                  <div className="container inner-container">
                    <div className="tab-pane active " id="Recentcases">
                      <TabTable childtabid={"BulkCase"} />
                    </div>
                  </div>
                </Row>
              ),
            },
            {
              id: 1,
              label: t("HPI.ProfilePage.EntitlementLabel", {
                defaultValue: "Entitlement",
              }),
              content: (
                <Row>
                  <div className="container inner-container">
                    <div className="tab-pane active " id="Recentcases">
                      <TabTable childtabid={"BulkEntitlement"} />
                    </div>
                  </div>
                </Row>
              ),
            },
            {
              id: 2,
              label: t("HPI.ProfilePage.ContactLabel", {
                defaultValue: "Contact",
              }),
              content: (
                <Row>
                  <div className="container inner-container">
                    <div className="tab-pane active " id="Recentcases">
                      <TabTable childtabid={"BulkContact"} />
                    </div>
                  </div>
                </Row>
              ),
            },
            // {
            //   id: 3,
            //   label: t("HPI.ProfilePage.SiteLabel", {
            //     defaultValue: "Site Account",
            //   }),
            //   content: (
            //     <Row>
            //       <div className="container inner-container">
            //         <div className="tab-pane active " id="Recentcases">
            //           <SiteAccountTab childtabid={"BulkSiteAccount"} />
            //         </div>
            //       </div>
            //     </Row>
            //   ),
            // },
          ]}
          type="attached"
        />
      </div>
    </div>
  );
};
